var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScheduling = function SvgScheduling(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "scheduling_svg2__a",
    x1: 5.81,
    x2: 158.28,
    y1: 175.61,
    y2: 40.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#scheduling_svg2__a",
    id: "scheduling_svg2__b",
    x1: -34.3,
    x2: 118.17,
    y1: 130.49,
    y2: -5.03
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#scheduling_svg2__a",
    id: "scheduling_svg2__c",
    x1: -19.08,
    x2: 133.39,
    y1: 147.62,
    y2: 12.09
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#scheduling_svg2__a",
    id: "scheduling_svg2__d",
    x1: -3.86,
    x2: 148.61,
    y1: 164.74,
    y2: 29.21
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#scheduling_svg2__a",
    id: "scheduling_svg2__e",
    x1: -20.6,
    x2: 131.87,
    y1: 145.91,
    y2: 10.38
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#scheduling_svg2__a",
    id: "scheduling_svg2__f",
    x1: -5.38,
    x2: 147.09,
    y1: 163.03,
    y2: 27.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#scheduling_svg2__a",
    id: "scheduling_svg2__g",
    x1: -6.9,
    x2: 145.57,
    y1: 161.32,
    y2: 25.79
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#scheduling_svg2__a",
    id: "scheduling_svg2__h",
    x1: 8.32,
    x2: 160.79,
    y1: 178.44,
    y2: 42.91
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#scheduling_svg2__a",
    id: "scheduling_svg2__i",
    x1: 46.95,
    x2: 199.42,
    y1: 221.89,
    y2: 86.37
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#scheduling_svg2__a",
    id: "scheduling_svg2__j",
    x1: 44.85,
    x2: 197.32,
    y1: 219.53,
    y2: 84
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M199.95 135.64a58.59 58.59 0 0 0-34.43-51.07V24.14c0-5.71-4.63-10.34-10.34-10.34h-10.34c0-5.71-4.63-10.34-10.34-10.34s-10.34 4.63-10.34 10.34h-13.79c0-5.71-4.63-10.34-10.34-10.34S89.69 8.09 89.69 13.8H75.9c0-5.71-4.63-10.34-10.34-10.34S55.22 8.09 55.22 13.8H41.43c0-5.71-4.63-10.34-10.34-10.34S20.75 8.09 20.75 13.8H10.41C4.63 13.8 0 18.43 0 24.14v144.83c0 1.9 1.54 3.45 3.45 3.45h10.34v10.34c0 1.9 1.54 3.45 3.45 3.45h90.8s.08-.02.12-.02c18.26 12.6 42.08 13.79 61.51 3.09 19.44-10.7 31.15-31.47 30.27-53.64ZM131.04 13.8a3.45 3.45 0 0 1 6.9 0v10.34h-6.9zm-34.49 0a3.45 3.45 0 0 1 6.9 0v10.34h-6.9zm-34.48 0a3.45 3.45 0 0 1 6.9 0v10.34h-6.9zm-34.48 0a3.45 3.45 0 0 1 6.9 0v10.34h-6.9zM6.9 24.14c0-1.9 1.54-3.45 3.45-3.45h10.34v6.9c0 1.9 1.54 3.45 3.45 3.45h13.79c1.9 0 3.45-1.54 3.45-3.45v-6.9h13.79v6.9c0 1.9 1.54 3.45 3.45 3.45h13.79c1.9 0 3.45-1.54 3.45-3.45v-6.9h13.79v6.9c0 1.9 1.54 3.45 3.45 3.45h13.79c1.9 0 3.45-1.54 3.45-3.45v-6.9h13.79v6.9c0 1.9 1.54 3.45 3.45 3.45h13.79c1.9 0 3.45-1.54 3.45-3.45v-6.9h10.34c1.9 0 3.45 1.54 3.45 3.45v17.24H6.9zm0 141.38V48.28h151.73v33.63c-5.58-1.72-11.4-2.6-17.24-2.6a58.59 58.59 0 0 0-50.28 28.45 58.59 58.59 0 0 0-1.42 57.75H6.9Zm13.79 13.8v-6.9h73.39c1.76 2.44 3.71 4.75 5.82 6.9zm120.69 10.34c-28.57 0-51.72-23.16-51.72-51.72s23.16-51.72 51.72-51.72c28.55.03 51.69 23.17 51.72 51.72 0 28.57-23.16 51.72-51.72 51.72",
    style: {
      fill: "url(#scheduling_svg2__a)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.03 62.07c-5.71 0-10.34 4.63-10.34 10.34s4.63 10.34 10.34 10.34 10.34-4.63 10.34-10.34-4.63-10.34-10.34-10.34m0 13.8a3.45 3.45 0 1 1 .001-6.901 3.45 3.45 0 0 1-.001 6.901",
    style: {
      strokeWidth: 0,
      fill: "url(#scheduling_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.52 62.07c-5.71 0-10.34 4.63-10.34 10.34s4.63 10.34 10.34 10.34 10.34-4.63 10.34-10.34-4.63-10.34-10.34-10.34m0 13.8a3.45 3.45 0 1 1 .001-6.901 3.45 3.45 0 0 1-.001 6.901",
    style: {
      strokeWidth: 0,
      fill: "url(#scheduling_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 82.76c5.71 0 10.34-4.63 10.34-10.34S105.71 62.08 100 62.08s-10.34 4.63-10.34 10.34S94.29 82.76 100 82.76m0-13.79a3.45 3.45 0 1 1-.001 6.901A3.45 3.45 0 0 1 100 68.97",
    style: {
      strokeWidth: 0,
      fill: "url(#scheduling_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.03 89.66c-5.71 0-10.34 4.63-10.34 10.34s4.63 10.34 10.34 10.34 10.34-4.63 10.34-10.34-4.63-10.34-10.34-10.34m0 13.79a3.45 3.45 0 1 1 .001-6.901 3.45 3.45 0 0 1-.001 6.901",
    style: {
      strokeWidth: 0,
      fill: "url(#scheduling_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.52 89.66c-5.71 0-10.34 4.63-10.34 10.34s4.63 10.34 10.34 10.34 10.34-4.63 10.34-10.34-4.63-10.34-10.34-10.34m0 13.79a3.45 3.45 0 1 1 .001-6.901 3.45 3.45 0 0 1-.001 6.901",
    style: {
      strokeWidth: 0,
      fill: "url(#scheduling_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.03 117.25c-5.71 0-10.34 4.63-10.34 10.34s4.63 10.34 10.34 10.34 10.34-4.63 10.34-10.34-4.63-10.34-10.34-10.34m0 13.79a3.45 3.45 0 1 1 .001-6.901 3.45 3.45 0 0 1-.001 6.901",
    style: {
      strokeWidth: 0,
      fill: "url(#scheduling_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.52 117.25c-5.71 0-10.34 4.63-10.34 10.34s4.63 10.34 10.34 10.34 10.34-4.63 10.34-10.34-4.63-10.34-10.34-10.34m0 13.79a3.45 3.45 0 1 1 .001-6.901 3.45 3.45 0 0 1-.001 6.901",
    style: {
      strokeWidth: 0,
      fill: "url(#scheduling_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.38 93.11c-24.75.03-44.8 20.08-44.83 44.83 0 24.76 20.07 44.83 44.83 44.83s44.83-20.07 44.83-44.83-20.07-44.83-44.83-44.83m31.04 51.72h6.24c-3.11 16.69-16.92 29.29-33.82 30.86v-6.72a3.45 3.45 0 0 0-6.9 0v6.72c-16.9-1.57-30.71-14.17-33.82-30.86h6.24a3.45 3.45 0 0 0 0-6.9h-6.9c.03-19.6 14.97-35.96 34.48-37.75v6.72a3.45 3.45 0 0 0 6.9 0v-6.72c19.52 1.8 34.46 18.16 34.48 37.75h-6.9a3.45 3.45 0 0 0 0 6.9",
    style: {
      strokeWidth: 0,
      fill: "url(#scheduling_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m159.86 121.49-17.74 14.79-4.77-7.15a3.46 3.46 0 0 0-4.78-.96 3.447 3.447 0 0 0-.95 4.78l6.9 10.34c.54.81 1.41 1.36 2.37 1.5a3.43 3.43 0 0 0 2.71-.76l20.69-17.24a3.455 3.455 0 0 0-4.42-5.31Z",
    style: {
      strokeWidth: 0,
      fill: "url(#scheduling_svg2__j)"
    }
  }));
};
export default SvgScheduling;